// extracted by mini-css-extract-plugin
export default {"containerPadding56":"conciergesDetails_containerPadding56__lyPkS","containerPadding56Mobile":"conciergesDetails_containerPadding56Mobile__rbgV9"};